import React from "react";

export default function Section4() {
  return (
    <div className="w-full Section3 px-5 md:px-0 pt-[2%]">
      <div className="flex flex-col items-center w-full md:flex-row justify-evenly section3-container">
        <div className="w-full md:w-[36%] text-[#373737]">
          <h2 className="text-[26px] md:text-[34px] font-bold leading-[32px] md:leading-[41px] text-[#DA2128] my-[0.67em] pb-[2%]">
            Shopify Development Experts
          </h2>
          <p className="leading-[20px] pb-[1%] text-base mb-5">
            At Mean3, we offer expert Shopify eCommerce development services for businesses. As a leading Shopify development company, we focus on building high-converting, mobile-friendly, and scalable Shopify websites that help you easily sell online.
          </p>
          <p className="leading-[20px] pb-[1%] text-base mb-5">
            Our team specializes in Shopify store development, offering complete Shopify services including custom design, theme setup, and third-party app integration. Whether starting a new store or improving an existing one, our Shopify website development services are tailored to meet your goals.
          </p>
          <p className="leading-[20px] pb-[1%] text-base mb-5">
            As a trusted Shopify agency, we provide reliable Shopify web development services backed by experience and technical expertise. We handle everything from secure checkout to user-friendly layouts to enhance your customers’ shopping journey.
          </p>
          <p className="leading-[20px] pb-[1%] text-base mb-5">
            "Ready to take your Shopify store to the next level? Mean3 delivers results that help your brand stand out and sell better on Shopify. Contact us today to get started!"
          </p>
        </div>

        <div className="w-full md:w-auto">
          <img
            src="../../../assets/computer-shopify.png"
            alt="Computer Logo"
            className="w-full md:w-auto cover"
          />
        </div>
      </div>
      <div className="line my-[55px] md:my-[4%] mx-auto w-[70%] md:w-[61%] shadow-line h-2 rounded-[100%]"></div>
    </div>
  );
}
